var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"default_limit":'1000',"default_sort":'email',"default_sort_typ":'ASC',"extension":'',"export_csv":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }